import { useMutation, useQuery } from '@tanstack/react-query';
import { minutesToMilliseconds } from 'date-fns';
import { useMemo } from 'react';
import { offlineAction } from '../functions/offline.helper';
export const useSettings = (api) => {
    const settingsQueryKey = useMemo(() => ['settings'], []);
    const userSettings = useQuery({
        queryKey: settingsQueryKey,
        queryFn: async () => {
            const { data } = await api.settings.getUserSettings();
            return data;
        },
        staleTime: minutesToMilliseconds(30),
    });
    const holidayYearSummary = useQuery({
        queryKey: [...settingsQueryKey, 'YearSummary'],
        queryFn: async () => {
            const { data } = await api.settings.getHolidayYearSummary();
            return data;
        },
        staleTime: minutesToMilliseconds(30),
    });
    const freeDays = useQuery({
        queryKey: [...settingsQueryKey, 'FreeDays'],
        queryFn: async () => {
            const { data } = await api.settings.getFreeDays();
            return data;
        },
        staleTime: minutesToMilliseconds(30),
    });
    const submitUserSettingsMutation = useMutation({
        networkMode: 'always',
        mutationFn: async (userSettings) => api.settings.submitUserSettings(userSettings),
    });
    const submitUserSettings = () => {
        const mutationAsync = async (userSettings, func) => {
            try {
                await submitUserSettingsMutation.mutateAsync(userSettings, {
                    onSuccess: () => {
                        func();
                    },
                });
            }
            catch (e) {
                offlineAction(e);
            }
        };
        return {
            mutationAsync,
            isLoading: submitUserSettingsMutation.isLoading,
        };
    };
    return {
        userSettings,
        holidayYearSummary,
        freeDays,
        submitUserSettings,
    };
};
